import { buildSecondaryPairFormSchema } from '../address/create-pair-form.js';
import { VendorAddressType } from './rules.js';
export const vendorAddressPairFormSchema = buildSecondaryPairFormSchema(VendorAddressType, {
    sameAsField: 'remitSameAsShipping',
    secondaryField: 'remit',
});
//# sourceMappingURL=create-pair-form.js.map